import React, { useRef, useLayoutEffect, useState } from 'react';
import classNames from 'classnames';
import { prefixCls } from '../../utils';
import './Fieldset.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const useCheckFieldSetHasRequired = fieldSetRef => {
  const [hasRequired, setHasRequired] = useState(false);
  useLayoutEffect(() => {
    if (fieldSetRef.current) {
      const requiredField = fieldSetRef.current.querySelector('.icloud-ui-form-required');
      setHasRequired(!!requiredField);
    } else {
      setHasRequired(false);
    }
  }, [fieldSetRef]);
  return {
    hasRequired
  };
};

export const FieldSet = ({
  className,
  title,
  description,
  children
}) => {
  const fieldSetRef = useRef(null);
  const {
    hasRequired
  } = useCheckFieldSetHasRequired(fieldSetRef);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(`${prefixCls}-fieldset`, {
      [`${prefixCls}-fieldset-no-required-field`]: !hasRequired
    }, className),
    children: [/*#__PURE__*/_jsx("div", {
      className: `${prefixCls}-fieldset-title`,
      children: title
    }), !!description && /*#__PURE__*/_jsx("div", {
      className: `${prefixCls}-fieldset-description`,
      children: description
    }), children]
  });
};
//# sourceMappingURL=es/FormUI/FieldSet/Fieldset.js.map